import {
  GET_TAGS,
  CREATE_TAG,
  UPDATE_TAG,
  SUCCESS,
  FAIL,
} from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isSubmitting: false,
  tags: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_TAGS:
      return { ...state, isLoading: true };
    case `${GET_TAGS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        tags: [...payload],
      };
    case `${GET_TAGS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case CREATE_TAG:
      return { ...state, isSubmitting: true };
    case `${CREATE_TAG}_${SUCCESS}`:
      return {
        ...state,
        isSubmitting: false,
        tags: [...state.tags, payload],
      };
    case `${CREATE_TAG}_${FAIL}`:
      return { ...state, isSubmitting: false, error: { ...payload } };

    case UPDATE_TAG:
      return { ...state, isSubmitting: true };
    case `${UPDATE_TAG}_${SUCCESS}`:
      return {
        ...state,
        isSubmitting: false,
        tags: state.tags.map((tag) => (tag.id === payload.id ? payload : tag)),
      };
    case `${UPDATE_TAG}_${FAIL}`:
      return { ...state, isSubmitting: false, error: { ...payload } };

    default:
      return state;
  }
};